export default function (mortgage, config){
    let fill = {}
    fill['undefined_3'] = {check: true}
    return {
        sections:[
            {fill}
        ]
    }
}